import { Divider } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import moment from 'moment-timezone';
import * as qs from 'qs';
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import WindsorApi from '../api/WindsorApi';
import LinkRouter from '../common/LinkRouter';
import LoadingIndicator from '../common/LoadingIndicator';
import GroupDetailsPageTable from './GroupDetailsPageTable';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: 'auto'
    },
    header: {
      marginBottom: 16,
    },
    tabs: {
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: darken(theme.palette.background.default, 0.03)
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    },
    breadcrumb: {
      marginBottom: 16
    },
    tabContent: {
      paddingTop: 16
    },
    groupDescription: {
      marginBottom: 16,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0
      }
    },
    textFieldInput: {
      paddingTop: 12,
      paddingBottom: 12
    },
    toolbar: {
      marginBottom: 8
    },
  })
);

const windsorApi = new WindsorApi();

const TabContent = ({ display, children, className }) => <div style={{ display: display ? 'block' : 'none' }} className={className}>{children}</div>;

function GroupDetailsPage(props: RouteComponentProps) {
  const { match: { params: { groupId } }, history, location } = props;
  const { tab = 'users' } = qs.parse(location.search, { ignoreQueryPrefix: true });
  const classes = useStyles({});
  const [group, setGroup] = useState(null);

  useEffect(() => {
    setGroup(null);
    windsorApi.getCspGroup(groupId).then(group => {
      const users = group.Users.map(u => u.toLowerCase());
      users.sort();

      group.Roles.sort();

      setGroup({
        name: group.Name,
        lastModified: group.LastModified,
        users: users,
        roles: group.Roles
      });
    });
  }, [groupId]);

  const onTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    history.replace({ search: `?tab=${newValue}` });
  };

  return group ? (
    <div className={classes.root}>
      <Breadcrumbs aria-label="breadcrumb">
        <LinkRouter color="textSecondary" to="/groups">
          Groups
        </LinkRouter>
        <Typography color="textPrimary">{group.name}</Typography>
      </Breadcrumbs>
      <Divider className={classes.divider} light />
      <div className={classes.header}>
        <Typography variant="h6" className={classes.groupDescription}>{group.name}</Typography>
        <Typography color="textSecondary">last synced {moment(group.lastModified).fromNow()}</Typography>
      </div>
      <Tabs
        className={classes.tabs}
        value={tab}
        onChange={onTabChange}
        aria-label="Group Tabs"
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Users" value="users" />
        <Tab label="Roles" value="roles" />
      </Tabs>
      <TabContent display={tab === 'users'} className={classes.tabContent}>
        <GroupDetailsPageTable
          items={group.users}
          noResultsText='This group does not contain any users'
          searchPlaceholder='search by user email'
        />
      </TabContent>
      <TabContent display={tab === 'roles'} className={classes.tabContent}>
        <GroupDetailsPageTable
          items={group.roles}
          noResultsText='This group does not contain any IAM roles'
          searchPlaceholder='search by role ARN'
        />
      </TabContent>
    </div>
  ) : <LoadingIndicator loading={true} />;
};

export default GroupDetailsPage;
